import { cx } from 'src/utils/cx'

interface QuestProgressBarProps {
  current: number
  max: number
  className?: string
}

export function QuestProgressBar({
  current,
  max,
  className,
}: QuestProgressBarProps) {
  const percentage = max > 0 ? Math.min((current / max) * 100, 100) : 0

  return (
    <div className={cx('flex items-center gap-2', className)}>
      <div className="flex-1 h-1.5 bg-zinc-200 dark:bg-zinc-700 rounded-full overflow-hidden">
        <div
          className="h-full bg-black dark:bg-white rounded-full transition-[width] duration-300"
          style={{ width: `${percentage}%` }}
        />
      </div>
      <span className="flex-none text-xs text-zinc-500 tabular-nums">
        {current}/{max}
      </span>
    </div>
  )
}
